"use client"

import { cn } from "../../utils/cn"
import React, { useEffect, useState, useRef } from "react"

import { RiVerifiedBadgeFill } from "react-icons/ri";


const Tooltip = ({ text }) => {
    return (
        <div
            className={cn(
                "absolute top-10  transform -translate-x-1/2 px-2 py-1 text-xs md:text-sm bg-zinc-900 text-white rounded-lg opacity-0 scale-0 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100",
            )}
        >
            {text}
        </div>
    )
}

export const InfiniteStack2 = ({ items, direction = "", speed = "slow", pauseOnHover = true, className }) => {
    const containerRef = useRef(null)
    const scrollerRef = useRef(null)
    const [start, setStart] = useState(false)

    useEffect(() => {
        addAnimation()
    }, [])

    function addAnimation() {
        if (containerRef.current && scrollerRef.current) {
            const scrollerContent = Array.from(scrollerRef.current.children)

            scrollerContent.forEach((item) => {
                const duplicatedItem = item.cloneNode(true)
                if (scrollerRef.current) {
                    scrollerRef.current.appendChild(duplicatedItem)
                }
            })

            getDirection()
            getSpeed()
            setStart(true)
        }
    }

    const getDirection = () => {
        if (containerRef.current) {
            if (direction === "left") {
                containerRef.current.style.setProperty("--animation-direction", "forwards")
            } else if (direction === "up") {
                containerRef.current.style.setProperty("--animation-direction", "forwards")
                containerRef.current.classList.add("vertical")
            } else if (direction === "down") {
                containerRef.current.style.setProperty("--animation-direction", "reverse")
                containerRef.current.classList.add("vertical")
            } else {
                containerRef.current.style.setProperty("--animation-direction", "reverse")
            }
        }
    }

    const getSpeed = () => {
        if (containerRef.current) {
            if (speed === "fast") {
                containerRef.current.style.setProperty("--animation-duration", "45s")
            } else if (speed === "slow") {
                containerRef.current.style.setProperty("--animation-duration", "60s")
            } else {
                containerRef.current.style.setProperty("--animation-duration", "45s")
            }
        }
    }

    const isVertical = direction === "up" || direction === "down"

    return (
        <div
            ref={containerRef}
            className={cn(
                "scroller relative z-20 overflow-hidden",
                isVertical
                    ? "h-screen w-full [mask-image:linear-gradient(to_bottom,transparent,white_20%,white_80%,transparent)]"
                    : "w-screen [mask-image:linear-gradient(to_right,transparent,white_20%,white_80%,transparent)]",
                className,
            )}
        >
            <ul
                ref={scrollerRef}
                className={cn(
                    "flex min-w-full shrink-0 gap-10 w-max flex-nowrap",
                    isVertical ? "flex-col" : "md:py-1.5",
                    start && (isVertical ? "animate-scroll-vertical" : "animate-scroll"),
                    pauseOnHover && "hover:[animation-play-state:paused]",
                )}
            >
                {items.map((card, idx) => (
                    <div key={idx} className="relative cursor-pointer group">
                        <div className="dark:bg-[#0f0f0f] bg-white dark:hover:bg-zinc-950 hover:bg-zinc-100 transition-all duration-200 w-[340px] rounded-2xl p-6 border dark:border-zinc-800/50 border-zinc-400">
                            <div className='w-full flex flex-col justify-start items-start'>
                                <div className="flex items-start gap-3">
                                    <img
                                        src={card?.img || "/placeholder.svg?height=48&width=48"}
                                        alt={card?.name || "Profile"}
                                        className="w-12 h-12 rounded-full object-cover"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <div className="flex flex-col">
                                            <span className="dark:text-zinc-200 text-zinc-900 font-medium text-base">{card?.name || "LinkedIn User"}</span>
                                            <span className="dark:text-zinc-500 text-zinc-800 text-sm">{card?.title || "Founder, Spain Academy"}</span>
                                        </div>

                                    </div>
                                    <div className='absolute top-5 right-5'>
                                        <RiVerifiedBadgeFill className='dark:text-white text-zinc-800 pt-0.5' />
                                        {/* <Tooltip text={'Verified'}/> */}
                                    </div>
                                </div>
                                <span className="dark:text-zinc-400  text-zinc-800 text-base mt-3 w-full">
                                    {card?.text ||
                                        "User Review"}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </ul>
        </div>
    )
}